<template>
    <div>
        <div id="chatting_buy_box">
            <div></div>
            <span>您还不是会员哦！查看和参与实时互动请先购买会员！</span>
            <button class="showToastBuyVIP" @click.stop.prevent="openPage">立即开通</button>
        </div>
    </div>
  </template>
  <script>
  export default {
    name: "UserProfiles",
    props: {
      
    },
    data() {
      return {

      }
    },
    created() {
    },
    methods: {
      openPage() {
        //调用父级方法， src\page\appProfiles\index.vue  openPage
        this.$parent.openPage('open_vip','开通')
      }
    }
  };
  </script>
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style lang="scss" scoped>
    #chatting_buy_box {
        display: flex;
        flex-direction: column;
        align-items: center;

        & > div {
            /*width: 255px;
            height: 190px;*/
            width: 204px;
            height: 152px;
            background-image: url("https://cdncos.aigupiao.com/assets/wap/img/chattingRoom/noData.svg");
            background-size: 100% 100%;
            background-repeat: no-repeat;
            background-position: center;
        }

        & > span {
            width: 230px;
            font-size: 15px;
            line-height: 23.25px;
            color: #333;
            margin-bottom: 10px;
            text-align: center;
        }

        & > button {
            width: 150px;
            height: 40px;
            border-radius: 20px;
            background-color: #FE484A;
            border: none;
            color: #fff;
            font-size: 15px;
            cursor: pointer;
        }
    }
  </style>